// INIT NAVIGATION STYLING
$(document).ready(function () {
	$('a.panel').click(function () {
		$('a.panel').removeClass('selected');
		$(this).addClass('selected');
		current = $(this);
		$('#wrapper').scrollTo($(this).attr('href'), 800);
		return false;
	});
});

$(document).ready(function () {
	$('input').click(function () {
		// Hide Label
		$(this).siblings('label').fadeOut(100);
	});
	$('input').blur(function () {
		if ($(this).val() === '') {
			$(this).siblings('label').fadeIn(100);
		}
	});
});


// INIT CUSTOM SCROLLBARS ONLY ON DESKTOP
$(document).ready(init_scroll);
$(window).on('resize', init_scroll);

function init_scroll() {
	if ($('body').width() >= 560) {
		$(".content").jScrollPane();
	}
}

// // START LIGHTCASE FROM EXTERNAL LINKS
// jQuery(document).ready(function ($) {
// 	$('.open-gallery').click(function (e) {
// 		e.preventDefault();
// 		$(".gallery." + $(this).attr('data-rel') + " a").first().click();
// 	});
// });

$(document).ready(function () {
	$('.venobox').venobox({
		numeratio: true,
		arrowsColor: '#FFFFFF',
		titlePosition: 'bottom',
		numerationColor: '#FFFFFF',
		numerationBackground: '',
		closeBackground: '',
		closeColor: '#FFFFFF',
		overlayColor: 'rgba(99,110,189,0.85)',
		titleColor: '#FFFFFF',
		titleBackground: '',
		spinner: 'spinner-pulse',
	});
});


// SHOW MORE ARTICLES
$(document).ready(show_more);
// $(window).on('resize', show_more);

function show_more() {
	if ($('body').width() <= 560) {
		$('.content--home').each(function () {
			var max = 2;
			if ($(this).find("article").length > max) {
				$(this)
					.find('article:gt(' + max + ')')
					.hide()
					.end()
					.append(
						$('<div class="show-more">Weitere Neuigkeiten...</div>').click(function () {
							$(this).siblings(':hidden').show({
								duration: 50,
							}).end().remove();
						})
					);
			}
		});
	}
}